import React from 'react';
import { Outlet } from 'react-router-dom';
import { Link } from 'react-router-dom';
export function AuthLayout() {
  return <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-116">
      <div className="max-w-md w-full space-y-8" data-id="element-117">
        <div data-id="element-118">
          <div className="flex justify-center" data-id="element-119">
            <Link to="/" className="flex items-center" data-id="element-120">
              <div className="bg-white p-3 rounded-lg shadow-lg" data-id="element-121">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9YiZ8fYR9MF9BFf8vhx3gU/Kastom_Printing_Logo.png" alt="Kastom Printing Logo" className="h-24 w-auto" data-id="element-122" />
              </div>
            </Link>
          </div>
          <Outlet data-id="element-123" />
        </div>
      </div>
    </div>;
}